import { BookMeNowEnvironment } from './interface';

export const environment: BookMeNowEnvironment = {
  production: true,
  devServer: false,
  name: 'PROD',
  snowplowId: 'd02c2828-f38e-419a-8d90-bfc7207274de',
};
